module.exports = __webpack_public_path__ + "ed7ac00668903a51091229c0c71dbb9a.pdf";